export default [
    {
        path: '/platinum/cache',
        props: true,
        component: () => import('@/views/PlatinumCache'),
    },
];
